const exportNTToExcel = async (data, fileName) => {

  const { default: ExcelJS } = await import("exceljs");
  const formatDate = (dateValue) => {
    if (!dateValue) return "";
    const d = new Date(dateValue);
    return `${String(d.getDate()).padStart(2,"0")}/${String(d.getMonth()+1).padStart(2,"0")}/${d.getFullYear()}`;
  };

  // Mapea filas desde el array original
  const rows = data.map(d => ({
    number_nt: d.number_nt || "",
    init_date_nt: formatDate(d.init_date_nt),
    end_date_nt: formatDate(d.end_date_nt),
    isindividual: d.isindividual ? "SÍ" : "NO",
    ismultiple: d.ismultiple ? "SÍ" : "NO",
    frecuency: d.frecuency || "",
    number_nt_refused: d.number_nt_refused || "",
    isemergency: d.isemergency ? "SÍ" : "NO",
    reason_emergency: d.reason_emergency || "",
    opt_doc: d.opt_tras_documentid || "",
    opt_name: d.opt_tras_tradename || "",
    opt_nima: d.opt_tras_nima || "",
    ori_doc: d.ori_tras_documentid || "",
    ori_name: d.ori_tras_tradename || "",
    ori_nima: d.ori_tras_nima || "",
    ori_street: d.ori_tras_street || "",
    ori_locality: d.ori_tras_locality || "",
    ori_postalcode: d.ori_tras_postalcode || "",
    dest_doc: d.dest_tras_documentid || "",
    dest_name: d.dest_tras_tradename || "",
    dest_nima: d.dest_tras_nima || "",
    dest_inscription: d.dest_tras_inscription || "",
    hasbeensentesir: d.hasbeensentesir ? "SÍ" : "NO",
    statussentesir: d.statussentesir ? "SÍ" : "NO",
    reasonrefund: d.reasonrefund || "",
    codeler_code: d.codeler_code || "",
    codeler_namees: d.codeler_namees || "",
    treatmenttypeorigin_code: d.treatmenttypeorigin_code || "",
    treatmenttypeorigin_namees: d.treatmenttypeorigin_namees || "",
    treatmenttypedestine_code: d.treatmenttypedestine_code || "",
    treatmenttypedestine_namees: d.treatmenttypedestine_namees || "",
    processtypepeorigin_code: d.processtypepeorigin_code || "",
    processtypepeorigin_namees: d.processtypepeorigin_namees || "",
    processtypedestine_code: d.processtypedestine_code || "",
    processtypedestine_namees: d.processtypedestine_namees || "",
    dangerousness_namees: d.dangerousness_namees || "",
    charac_danger: d.charac_danger || "",
    amount: typeof d.amount === "number" ? d.amount : Number(d.amount ?? 0)
  }));

  const wb = new ExcelJS.Workbook();
  const ws = wb.addWorksheet("NOTIFICACIONES PREVIAS", { properties: { defaultRowHeight: 18 } });

  // Definición de columnas (orden corregido para coincidir con los datos)
  ws.columns = [
    { header: "Nº NOTIFICACIÓN PREVIA", key: "number_nt", width: 22 },
    { header: "FECHA PRIMER TRASLADO", key: "init_date_nt", width: 20 },
    { header: "FECHA FINAL TRASLADO", key: "end_date_nt", width: 20 },
    { header: "INDIVIDUAL", key: "isindividual", width: 12 },
    { header: "MÚLTIPLE", key: "ismultiple", width: 12 },
    { header: "FRECUENCIA", key: "frecuency", width: 14 },
    { header: "Nº DOCUMENTO RECHAZADO", key: "number_nt_refused", width: 22 },
    { header: "EMERGENCIA", key: "isemergency", width: 12 },
    { header: "MOTIVO EMERGENCIA", key: "reason_emergency", width: 28 },
    { header: "OPERADOR Nº DOCUMENTO", key: "opt_doc", width: 22 },
    { header: "OPERADOR RAZÓN SOCIAL", key: "opt_name", width: 28 },
    { header: "OPERADOR NIMA", key: "opt_nima", width: 16 },
    { header: "ORIGEN Nº DOCUMENTO", key: "ori_doc", width: 22 },
    { header: "ORIGEN RAZÓN SOCIAL", key: "ori_name", width: 28 },
    { header: "ORIGEN NIMA", key: "ori_nima", width: 16 },
    { header: "ORIGEN DIRECCIÓN", key: "ori_street", width: 28 },
    { header: "ORIGEN LOCALIDAD", key: "ori_locality", width: 20 },
    { header: "ORIGEN CÓDIGO POSTAL", key: "ori_postalcode", width: 18 },
    { header: "DESTINO Nº DOCUMENTO", key: "dest_doc", width: 22 },
    { header: "DESTINO RAZÓN SOCIAL", key: "dest_name", width: 28 },
    { header: "DESTINO NIMA", key: "dest_nima", width: 16 },
    { header: "ORIGEN Nº INSCRIPCIÓN", key: "dest_inscription", width: 22 },
    { header: "ENVIADO A ESIR", key: "hasbeensentesir", width: 16 },
    { header: "ESTADO", key: "statussentesir", width: 14 },
    { header: "MOTIVO RECHAZO ESIR", key: "reasonrefund", width: 26 },
    { header: "CÓDIGO LER", key: "codeler_code", width: 14 },
    { header: "DESCRIPCIÓN LER", key: "codeler_namees", width: 30 },
    { header: "CÓDIGO TRAT. ORIGEN", key: "treatmenttypeorigin_code", width: 20 },
    { header: "DESCRIPCIÓN TRAT. ORIGEN", key: "treatmenttypeorigin_namees", width: 28 },
    { header: "CÓDIGO TRAT. DESTINO", key: "treatmenttypedestine_code", width: 20 },
    { header: "DESCRIPCIÓN TRAT. DESTINO", key: "treatmenttypedestine_namees", width: 28 },
    { header: "CÓDIGO PROCESO ORIGEN", key: "processtypepeorigin_code", width: 22 },
    { header: "DESCRIPCIÓN PROC. ORIGEN", key: "processtypepeorigin_namees", width: 28 },
    { header: "CÓDIGO PROCESO DESTINO", key: "processtypedestine_code", width: 22 },
    { header: "DESCRIPCIÓN PROC. DESTINO", key: "processtypedestine_namees", width: 28 },
    { header: "CÓDIGO PELIGROSIDAD", key: "dangerousness_namees", width: 20 },
    { header: "CARACTERÍSTICAS", key: "charac_danger", width: 24 },
    { header: "CANTIDAD", key: "amount", width: 14, style: { numFmt: '#,##0.00' } }
  ];

  // Añadir filas
  ws.addRows(rows);

  // Estilo cabecera
  const headerRow = ws.getRow(1);
  headerRow.height = 22;
  headerRow.font = { bold: true, color: { argb: "FFFFFFFF" }, size: 12 };
  headerRow.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
  headerRow.eachCell((cell) => {
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "a7b8ee" } };
    cell.border = {
      top: { style: "thin", color: { argb: "FFFFFFFF" } },
      bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
      left: { style: "thin", color: { argb: "FFFFFFFF" } },
      right: { style: "thin", color: { argb: "FFFFFFFF" } }
    };
  });

  // Zebra striping + bordes suaves en datos
  ws.eachRow((row, rowNumber) => {
    if (rowNumber === 1) return;
    row.alignment = { vertical: "middle", horizontal: "left", wrapText: true };
    row.eachCell((cell) => {
      cell.border = {
        top: { style: "hair" }, bottom: { style: "hair" }, left: { style: "hair" }, right: { style: "hair" }
      };
      if (rowNumber % 2 === 0) {
        cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFF3F6FA" } };
      }
    });
  });

  // Congelar cabecera y autofiltro
  ws.views = [{ state: "frozen", ySplit: 1 }];
  ws.autoFilter = { from: { row: 1, column: 1 }, to: { row: 1, column: ws.columnCount } };

  // Fila de totales para CANTIDAD
  const lastDataRow = ws.lastRow.number;
  const totalRow = ws.addRow([]);
  totalRow.getCell(ws.columnCount - 0).value = { // columna "CANTIDAD"
    formula: `SUM(${ws.getColumn("amount").letter}2:${ws.getColumn("amount").letter}${lastDataRow})`
  };
  totalRow.getCell(ws.columnCount - 0).numFmt = '#,##0.00';
  totalRow.font = { bold: true };
  totalRow.getCell(ws.columnCount - 1).alignment = { horizontal: "right" };

  // Descargar
  const safeFileName = fileName.endsWith(".xlsx") ? fileName : `${fileName}.xlsx`;
  const buffer = await wb.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = safeFileName;
  a.click();
  window.URL.revokeObjectURL(url);
};

export default exportNTToExcel;
